module.exports = __webpack_public_path__ + "static/ForThePeople4-d31a09b2d6de48754e3ee78ac8e6fa2c.webp";